import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useGetSetting } from 'api/settings'
import { consentActions } from 'store/consent'

export const useCookieConsentBootstrap = () => {
  const dispatch = useDispatch()
  const { setting } = useGetSetting()
  const bannerEnabled = setting?.cookieBannerEnabled === true

  useEffect(() => {
    if (setting) {
      dispatch(consentActions.setCookieBannerEnabled(bannerEnabled))
    }
  }, [setting, bannerEnabled, dispatch])
}
